import "../channelPartnersForm/ChannelPartnersForm.scss";
import { MdArrowOutward } from "react-icons/md";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import TextError from "../texterror/TextError";
import { useRef, useState } from "react";

const VendorPartnersForm = ({
  partnersFormAPi,
  loader,
  forUsed,
  setForUsed,
  viewMsg,
}) => {
  const [msgStatus, setStatus] = useState(false);

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    number: "",
    company_name: "",
    country: "",
    job_title: "",
    help: "",
    solution_offer: [],
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required("Field is required!"),
    last_name: Yup.string().required("Field is required!"),
    email: Yup.string()
      .email("Invalid email formate!")
      .required("Email is required!"),
    number: Yup.string().required("Field is required!"),
    company_name: Yup.string().required("Field is required!"),
    country: Yup.string().required("Field is required!"),
    job_title: Yup.string().required("Field is required!"),
    help: Yup.string().required("Field is required!"),
  });

  const onSubmit = (values, { resetForm }) => {
    setForUsed("vendor");
    partnersFormAPi({
      ...values,
      category: "Vendor",
    });
    resetForm();
  };

  return (
    <div className="partner_form_wrap">
      {viewMsg && forUsed === "vendor" ? (
        <div className="msg_wrap p_top p_bottom">
          <h2>
            Thank you for reaching out! Our team will get back to you soon.
          </h2>
        </div>
      ) : (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          <Form>
            <h3><b>For Vendor Partners</b></h3>
            {/* For Vendor Partners */}
            <div className="bi_field">
              <div className="input_field wow fadeInUp">
                <label>First Name*</label>
                <Field
                  type="text"
                  placeholder="Enter"
                  id="first_name"
                  name="first_name"
                  autoComplete="off"
                />
                <ErrorMessage name="first_name" component={TextError} />
              </div>

              <div className="input_field wow fadeInUp" data-wow-delay="0.1s">
                <label>Last Name*</label>
                <Field
                  type="text"
                  placeholder="Enter"
                  id="last_name"
                  name="last_name"
                  autoComplete="off"
                />
                <ErrorMessage name="last_name" component={TextError} />
              </div>
            </div>

            <div className="input_field wow fadeInUp">
              <label>Email*</label>
              <Field
                type="email"
                placeholder="Enter"
                id="email"
                name="email"
                autoComplete="off"
              />
              <ErrorMessage name="email" component={TextError} />
            </div>

            <div className="input_field wow fadeInUp">
              <label>Phone Number</label>
              <Field
                type="number"
                placeholder="Enter"
                id="number"
                name="number"
                autoComplete="off"
              />
              <ErrorMessage name="number" component={TextError} />
            </div>

            <div className="bi_field">
              <div className="input_field wow fadeInUp">
                <label>Company name*</label>
                <Field
                  type="text"
                  placeholder="Enter"
                  id="company_name"
                  name="company_name"
                  autoComplete="off"
                />
                <ErrorMessage name="company_name" component={TextError} />
              </div>

              <div className="input_field wow fadeInUp">
                <label>Country/Region</label>
                <Field
                  type="text"
                  placeholder="Enter"
                  id="country"
                  name="country"
                  autoComplete="off"
                />
                <ErrorMessage name="country" component={TextError} />
              </div>
            </div>

            <div className="input_field wow fadeInUp">
              <label>Job title*</label>
              <Field
                type="text"
                placeholder="Enter"
                id="job_title"
                name="job_title"
                autoComplete="off"
              />
              <ErrorMessage name="job_title" component={TextError} />
            </div>

            <div className="input_field wow fadeInUp">
              <label>How can we help?*</label>
              <Field
                as="textarea"
                type="text"
                placeholder="Enter"
                id="help"
                name="help"
                autoComplete="off"
              />
              <ErrorMessage name="help" component={TextError} />
            </div>

            <div className="checkbox_field">
              <label>What solutions do you offer?</label>
              <div className="checkbox_line">
                <Field type="checkbox" name="solution_offer" value="first" />
                <p className="t-14">First lorem ipsum</p>
              </div>
              <div className="checkbox_line">
                <Field type="checkbox" name="solution_offer" value="second" />
                <p className="t-14">Second lorem ipsum</p>
              </div>
              <div className="checkbox_line">
                <Field type="checkbox" name="solution_offer" value="third" />
                <p className="t-14">Third lorem ipsum</p>
              </div>
              <div className="checkbox_line">
                <Field type="checkbox" name="solution_offer" value="fourth" />
                <p className="t-14">Fourth lorem ipsum</p>
              </div>
            </div>

            <p className="t-12" style={{ marginTop: "16px" }}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam
              cupiditate quaerat unde quibusdam aliquam! Et!
            </p>

            <button
              className="primary_btns ${classList} secondary_ternery wow fadeInUp"
              type="submit"
            >
              {loader && forUsed === "vendor" ? "Loading..." : "Submit"}
              <MdArrowOutward />
            </button>
          </Form>
        </Formik>
      )}
    </div>
  );
};

export default VendorPartnersForm;
